/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

const styles = {
  badge: css`
    display: inline-block;
    background-color: #d3ddf4;
    padding: 1px 5px;
    border-radius: 4px;
  `,
  badgeText: css`
    font-weight: 600;
    white-space: nowrap;
  `,
};

const Badge: React.LegacyFunctionComponentWithChildren = ({ children }) => {
  return (
    <div css={styles.badge}>
      <Typography2 variant="subtitleMedium" component="div" color="highlightBlue" css={styles.badgeText}>
        {children}
      </Typography2>
    </div>
  );
};

export default Badge;
